import { Modal } from 'react-bootstrap';
import { IoChevronBackOutline, IoChevronForwardOutline, IoCloseOutline } from 'react-icons/io5';
import moment from 'moment';
import { useEffect, useState } from 'react';

import { formatMinutes } from 'utils/helpers';
import PlaceHolderItemList from 'components/loader/PlaceHolderItemList';

// Servizi mostrati per pagina (coerente con il mock: pochi per pagina, resto paginato).
const PAGE_SIZE = 4;

// Data leggibile o trattino se assente.
function fmtDate(value) {
    if (!value) return '-';
    const m = moment(value);
    return m.isValid() ? m.format('DD/MM/YYYY HH:mm') : '-';
}

function ServiceRow({ service }) {
    const done = service.done;
    const qty = service.quantity || 0;

    return (
        <div className="mb-3 d-flex align-items-center">
            {/* Immobile: via con il cliente fra parentesi */}
            <div style={{ flex: '0 0 200px', minWidth: 0 }} className="me-3">
                {service.building && <div className="text-white text-13">{service.building}</div>}
                <div className="text-12">({service.customer})</div>
            </div>
            {/* Servizio: nome + barra di avanzamento */}
            <div style={{ flex: '1 1 auto', minWidth: 0 }} className="me-3">
                <div className="fw-500 mb-1">{service.service}</div>
                <div className="progress position-relative w-100">
                    <div
                        className={`progress-bar bg-${done ? 'success' : 'warning'}`}
                        role="progressbar"
                        style={{ width: '100%' }}
                        aria-valuenow={done ? qty : 0}
                        aria-valuemin="0"
                        aria-valuemax={qty}
                    >
                        <span className="progress-text">{done ? qty : 0}/{qty}</span>
                    </div>
                </div>
            </div>
            <div className="text-center text-12" style={{ flex: '0 0 130px' }}>{fmtDate(service.assigned_at)}</div>
            <div className="text-center text-12" style={{ flex: '0 0 130px' }}>{fmtDate(service.hd_uploaded_at)}</div>
            <div className="text-center text-12" style={{ flex: '0 0 130px' }}>{fmtDate(service.editing_end_at)}</div>
        </div>
    );
}

export default function EditorSpecModal({ show, onClose, editor, periodLabel, spec }) {

    const [page, setPage] = useState(0);

    // Reset pagina ad ogni apertura/cambio editor.
    useEffect(() => { setPage(0); }, [editor?.id, show]);

    const services = spec?.services || [];
    const totalPages = Math.max(1, Math.ceil(services.length / PAGE_SIZE));
    const pageItems = services.slice(page * PAGE_SIZE, page * PAGE_SIZE + PAGE_SIZE);

    return (
        <Modal className="dialogbox editor-spec-wide" show={show} onHide={onClose} centered>

            <style>{`
                .editor-spec-wide .modal-dialog { transform: scale(1) !important; max-width: none !important; }
                .editor-spec-wide .modal-content { max-width: 1100px !important; width: 92vw !important; max-height: 85vh !important; }
            `}</style>
            <Modal.Body className="text-gray position-relative d-flex flex-column p-4">
                {/* Chiusura in alto a destra */}
                <a className="close-btn-modal text-25" role="button" onClick={onClose}>
                    <IoCloseOutline />
                </a>

                {/* Intestazione */}
                <div className="text-center mb-3">
                    <h3 className="mb-1 text-white">Statistiche utente</h3>
                    <div className="text-14">{editor?.name}</div>
                    <div className="mt-2">
                        <span className="badge bg-dark px-3 py-2 text-14">{periodLabel}</span>
                    </div>
                </div>

                <div className="d-flex justify-content-center gap-4 mb-2 text-14">
                    <span>Completati: <b className="text-white">{spec ? spec.completed_count : '-'}</b></span>
                    <span>Tempo medio: <b className="text-white">{spec ? formatMinutes(spec.average_time_minutes) : '-'}</b></span>
                </div>

                <hr className="line-divider my-2" />

                {/* Intestazione colonne date */}
                <div className="d-flex align-items-center text-12 text-gray fw-500 mb-3">
                    <div style={{ flex: '0 0 200px' }} className="me-3">Immobile</div>
                    <div style={{ flex: '1 1 auto' }} className="me-3">Servizio</div>
                    <div className="text-center" style={{ flex: '0 0 130px' }}>Data assegnazione</div>
                    <div className="text-center" style={{ flex: '0 0 130px' }}>Data caricamento hd</div>
                    <div className="text-center" style={{ flex: '0 0 130px' }}>Data fine editing</div>
                </div>

                {/* Contenuto */}
                {!spec && (
                    <div className="placeholder-glow">
                        {Array(3).fill(null).map((_, i) => <div key={i} className="mb-3"><PlaceHolderItemList /></div>)}
                    </div>
                )}

                {spec && services.length === 0 && (
                    <div className="text-center text-gray py-4">
                        Nessun servizio assegnato nel periodo selezionato.
                    </div>
                )}

                {spec && pageItems.map(service => (
                    <ServiceRow key={service.task_id} service={service} />
                ))}

                {/* Paginazione */}
                {spec && services.length > 0 && (
                    <div className="d-flex align-items-center justify-content-center gap-3 mt-3">
                        <a
                            role="button"
                            className={`headerButton ${page === 0 ? 'disabled text-gray' : ''}`}
                            onClick={() => page > 0 && setPage(page - 1)}
                        >
                            <IoChevronBackOutline />
                        </a>
                        <span className="text-14">{page + 1} /{totalPages}</span>
                        <a
                            role="button"
                            className={`headerButton ${page >= totalPages - 1 ? 'disabled text-gray' : ''}`}
                            onClick={() => page < totalPages - 1 && setPage(page + 1)}
                        >
                            <IoChevronForwardOutline />
                        </a>
                    </div>
                )}

            </Modal.Body>
        </Modal>
    );
}
